import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "node-metadata" }
const _hoisted_2 = { class: "metadata-summary" }
const _hoisted_3 = ["aria-expanded", "aria-controls"]
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 0,
  class: "metadata-chips"
}
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 1,
  class: "empty-metadata"
}
const _hoisted_8 = {
  key: 0,
  class: "metadata-chips"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 1,
  class: "empty-metadata"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.taints.length) + " " + _toDisplayString(_ctx.taintsLabel.toLowerCase()), 1),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "summary-divider",
        "aria-hidden": "true"
      }, "·", -1)),
      _cache[3] || (_cache[3] = _createTextVNode()),
      _createElementVNode("span", null, _toDisplayString(_ctx.labels.length) + " " + _toDisplayString(_ctx.labelsLabel.toLowerCase()), 1),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _createElementVNode("button", {
        type: "button",
        "aria-expanded": _ctx.expanded,
        "aria-controls": _ctx.contentId,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.expanded = !_ctx.expanded), ["stop"]))
      }, [
        _createTextVNode(_toDisplayString(_ctx.detailsLabel) + " ", 1),
        _createElementVNode("i", {
          class: _normalizeClass(["icon", _ctx.expanded ? 'icon-chevron-up' : 'icon-chevron-down']),
          "aria-hidden": "true"
        }, null, 2)
      ], 8, _hoisted_3)
    ]),
    _cache[8] || (_cache[8] = _createTextVNode()),
    (_ctx.expanded)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: _ctx.contentId,
          class: "metadata-details"
        }, [
          _createElementVNode("section", null, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.taintsLabel), 1),
            _cache[5] || (_cache[5] = _createTextVNode()),
            (_ctx.taints.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taints, (taint, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: index,
                      class: "metadata-chip",
                      title: _ctx.taintText(taint)
                    }, _toDisplayString(_ctx.taintText(taint)), 9, _hoisted_6))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_7, "\n          None\n        "))
          ]),
          _cache[7] || (_cache[7] = _createTextVNode()),
          _createElementVNode("section", null, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.labelsLabel), 1),
            _cache[6] || (_cache[6] = _createTextVNode()),
            (_ctx.labels.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: index,
                      class: "metadata-chip",
                      title: label
                    }, _toDisplayString(label), 9, _hoisted_9))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_10, "\n          None\n        "))
          ])
        ], 8, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}